import { render, staticRenderFns } from "./MathSvg.vue?vue&type=template&id=b592455e&"
import script from "./MathSvg.vue?vue&type=script&lang=ts&"
export * from "./MathSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b592455e', component.options)
    } else {
      api.reload('b592455e', component.options)
    }
    module.hot.accept("./MathSvg.vue?vue&type=template&id=b592455e&", function () {
      api.rerender('b592455e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/MathSvg.vue"
export default component.exports